import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class Portfolio {
  constructor() {
    this.filterSliderInit();
    this.filterInit();
    this.loadInit();
    this.closeModal();
    this.modalSliderInit();
  }
  closeModal = () => {
    const modal = document.querySelector(".js-portfolio-modal");
    modal.addEventListener("click", (e) => {
      e.stopPropagation();
      if (
        !e.target.classList.contains("js-portfolio-modal-content") &&
        !e.target.classList.contains("portfolio__modal-arrows--arrow")
      ) {
        modal.classList.remove("active");
        document.body.classList.remove("stop-scroll");
      }
    });
  };
  filterSliderInit = () => {
    const slider = new Swiper(".js-portfolio-options", {
      grabCursor: true,
      slidesPerView: "auto",
    });
  };
  filterInit = () => {
    const filters = document.querySelectorAll(".js-portfolio-filter");
    filters.forEach((filter) => {
      filter.addEventListener("click", () => {
        filters.forEach((f) => {
          if (f != filter) {
            f.classList.remove("active");
          }
        });
        filter.classList.add("active");
        this.fetchData(filter.getAttribute("data-slug"));
      });
    });
  };
  modalSliderInit = () => {
    const slider = new Swiper(".js-portfolio-modal-slider", {
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        nextEl: ".js-modal-slider-next",
        prevEl: ".js-modal-slider-prev",
      },
    });
    const items = document.querySelectorAll(".js-portfolio-item");
    const modal = document.querySelector(".js-portfolio-modal");
    items.forEach((item, index) => {
      item.addEventListener("click", () => {
        modal.classList.add("active");
        document.body.classList.add("stop-scroll");
        slider.slideTo(index, 0);
      });
    });
  };
  fetchData = async (filter) => {
    const wrapper = document.querySelector(".js-portfolio-wrapper");
    const spinner = document.querySelector(".js-spinner");
    const modalWrapper = document.querySelector(".js-portfolio-modal-content");
    let formData = new FormData();
    formData.append("action", "portfolio_filter");
    formData.append("filter", filter);
    wrapper.classList.add("animating");
    spinner.classList.add("active");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
    modalWrapper.innerHTML = data.modal;
    this.loadInit();
    wrapper.classList.remove("animating");
    spinner.classList.remove("active");
    this.modalSliderInit();
  };
  loadInit = () => {
    const btn = document.querySelector(".js-portfolio-btn");
    btn?.addEventListener("click", () => {
      this.fetchLoad(
        btn.getAttribute("data-filter"),
        btn.getAttribute("data-page"),
        btn
      );
    });
  };
  fetchLoad = async (filter, page, el) => {
    const wrapper = document.querySelector(".js-portfolio-load");
    const modalWrapper = document.querySelector(".js-portfolio-modal-content");
    const spinner = document.querySelector(".js-spinner");
    let formData = new FormData();
    formData.append("action", "portfolio_loadmore");
    formData.append("filter", filter);
    formData.append("page", page);
    wrapper.classList.add("animating");
    spinner.classList.add("active");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML += data.files;
    wrapper.parentNode.removeChild(el);
    modalWrapper.innerHTML = data.modal;
    if (document.querySelectorAll(".js-portfolio-item").length != data.max) {
      wrapper.parentNode.appendChild(el);
      el.setAttribute("data-page", parseInt(page) + 1);
    }
    wrapper.classList.remove("animating");
    spinner.classList.remove("active");
    this.modalSliderInit();
  };
}
export default Portfolio;

new Portfolio();
